"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.Html = exports.HeaderText = exports.HeaderContainer = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(6),
        [theme.breakpoints.up('md')]: {
            [".".concat(_presentationComponents.tableClasses.root)]: {
                margin: '0 auto'
            }
        }
    };
});
const HeaderText = exports.HeaderText = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up('md')]: {
            margin: '0 auto'
        }
    };
});
const HeaderContainer = exports.HeaderContainer = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.spacing(2),
        '&:empty': {
            display: 'none'
        },
        [theme.breakpoints.up('md')]: {
            gap: theme.spacing(3)
        }
    };
});
const Html = exports.Html = (0, _mui.styled)(_presentationComponents.TextWithHtml)((param)=>{
    let { theme } = param;
    return {
        [".".concat(_presentationComponents.textWithHtmlClasses.text)]: {
            fontSize: theme.typography.body1.fontSize
        }
    };
});
